 <template>
  <div>
    <v-dialog v-model="signature_dialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Signature ({{project_details ? project_details.bill_to :''}})</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" v-if="active_page == 1">
              <div class="container">
                <VueSignaturePad
                  id="customer_signature"
                  width="100%"
                  height="80px"
                  ref="customerSignaturePad"
                  :options="{onBegin: () => {$refs.customerSignaturePad.resizeCanvas()}}"
                />
              </div>
              <div class="mt-2 text-center">
                <v-btn
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.undoSignature()"
                >
                  Undo
                </v-btn>
                <v-btn
                  class="ml-2"
                  outlined
                  small=""
                  @click="$refs.customerSignaturePad.clearSignature()"
                >
                  Clear
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" v-else>
              <div class="container">
                <img :src="customer_sign" />
              </div>
            </v-col>
            <v-col cols="12" class="mt-3" v-if="displayNote">
              <h3>Note: </h3>
              <v-textarea
                v-model="note"
                outlined=""
                rows="3"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="skipSignature()" class="error">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="saveSignature()"
          >{{(active_page == 1)?'Ok':'Accept & Sign'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      user_sign_blob: '',
      customer_sign_blob: '',
      erro_msg: '',
      note: ''
    }
  },
  props: ['signature_dialog','project_details','displayNote','active_page','customer_sign'],
  watch: {
  },
  computed: {
    user_name() {
      return localStorage.getItem('user_name');
    },
    sign_image() {
      var reader = new FileReader();
      return reader.readAsDataURL(this.customer_sign)
    }
  },
  components: {
  },
   methods: {    
     saveSignature() {
      //let userImageData = this.$refs.userSignaturePad.saveSignature('image/png');
      //if(!userImageData.isEmpty) {
        this.erro_msg = ''
        //this.user_sign_blob = userImageData.data
        if(this.active_page == 1) {
          let customerImageData = this.$refs.customerSignaturePad.saveSignature('image/png');
          if(!customerImageData.isEmpty) {
            this.customer_sign_blob = customerImageData.data
          } else {
            this.customer_sign_blob = ''
          }
        }
        let data = {
          user_sign_blob: this.user_sign_blob,
          customer_sign_blob: this.customer_sign_blob,
          note: this.note
        }
        //this.$refs.userSignaturePad.clearSignature();
        if(this.active_page == 1) {
          this.$refs.customerSignaturePad.clearSignature();
        }
        this.$emit('updateValue',data);
        this.note = ''
      // } else {
      //   this.erro_msg = "Please fill signature"
      // }
    },
    skipSignature() {
      if(this.active_page == 1) {
        this.$refs.customerSignaturePad.clearSignature();
      }
      this.erro_msg = ''
      //this.$refs.userSignaturePad.clearSignature();
      this.user_sign_blob = ''
      this.customer_sign_blob = ''
      this.note = ''
      let data = {
        user_sign_blob: this.user_sign_blob,
        customer_sign_blob: this.customer_sign_blob,
        note: this.note
      }
      this.$emit('clearValue',data);
    },
  },
  created: function() {
  },
  mounted: function () {
  }
 }
 </script>
<style scoped>
.container {
  width: "100%";
  padding: 8px 16px;
  border: solid 1px;
}
 </style>